// eslint-disable-next-line no-console
console.log('Registered beforeunload');
// eslint-disable-next-line no-unused-vars
var finformUnsavedChanges = false; //Has to be set in app's form-selector, not set from finra-forms like areFinformArraysOpen.
// eslint-disable-next-line no-unused-vars
var areFinformArraysOpen = false; //This will be true if any form array/modal is opened, even if closed with no changes remains true.
//beforeunload listener prompts generic 'Leave Site' popup instead of returnValue msg.
window.addEventListener('beforeunload', (event) => {
  //console.log('areFinformArraysOpen', window.areFinformArraysOpen);
  //console.log('finformUnsavedChanges', window.finformUnsavedChanges);
  //beforeunload will not unload in gateway until leaving and returning to mu1 so need to set finformUnsavedChanges to false if not currently on mu1 page.
  if (
    window.finformUnsavedChanges &&
    !event.target.URL.includes('/forms/mu1') &&
    !event.target.URL.includes('localhost')
  ) {
    globalThis.finformUnsavedChanges = false;
  }
  if (window.finformUnsavedChanges) {
    event.returnValue = 'You have unfinished changes!';
  }
});
